var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "500px" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { attrs: { "min-width": "500px" } },
        [
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2 pa-0",
                  attrs: { icon: "", color: "red" },
                  on: { click: _vm.onClose },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0", attrs: { dense: "" } },
            [
              _c("v-spacer"),
              _vm._l(_vm.getAudiences(), function (audience, index) {
                return [
                  _c("v-checkbox", {
                    key: audience.name,
                    style: {
                      "margin-left": (index != 0 ? 10 : 0) + "px",
                      "margin-top": "-10px",
                      "margin-bottom": "10px",
                    },
                    attrs: {
                      color: "blue",
                      label: audience.name.toUpperCase(),
                      value: audience.name,
                    },
                    model: {
                      value: _vm.selected,
                      callback: function ($$v) {
                        _vm.selected = $$v
                      },
                      expression: "selected",
                    },
                  }),
                ]
              }),
              _c("v-spacer"),
            ],
            2
          ),
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0", attrs: { dense: "" } },
            [
              _c("v-spacer"),
              _vm._l(_vm.getCustomAudiences(), function (audience, index) {
                return [
                  _c("v-checkbox", {
                    key: audience.name,
                    style: {
                      "margin-left": (index != 0 ? 10 : 0) + "px",
                      "margin-top": "-10px",
                      "margin-bottom": "20px",
                    },
                    attrs: {
                      color: "red",
                      label: audience.name.toUpperCase(),
                      value: audience.name,
                    },
                    model: {
                      value: _vm.selected,
                      callback: function ($$v) {
                        _vm.selected = $$v
                      },
                      expression: "selected",
                    },
                  }),
                ]
              }),
              _c("v-spacer"),
            ],
            2
          ),
          _c(
            "v-card-actions",
            { staticStyle: { "margin-top": "-25px" } },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2 white--text",
                  attrs: {
                    loading: _vm.buttonLoading,
                    elevation: "0",
                    disabled: _vm.uid == null,
                    color: "blue",
                  },
                  on: { click: _vm.onPressDeploy },
                },
                [_vm._v("DEPLOY ")]
              ),
              _c("v-spacer"),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }